import React from "react";
import { useTheme } from "styled-components";

const OtherModules = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.313 3.375H3.938a.563.563 0 0 0-.563.563v3.375c0 .31.252.562.563.562h3.375c.31 0 .562-.252.562-.562V3.938a.563.563 0 0 0-.562-.563m4.684-.537-2.403 2.37a.56.56 0 0 0-.006.795l2.37 2.403a.563.563 0 0 0 .795.006l2.403-2.37a.563.563 0 0 0 .006-.795l-2.37-2.403a.56.56 0 0 0-.795-.006m-4.684 7.287H3.938a.56.56 0 0 0-.563.563v3.374c0 .311.252.563.563.563h3.375c.31 0 .562-.252.562-.562v-3.376a.56.56 0 0 0-.562-.562m6.75 0h-3.376a.56.56 0 0 0-.562.563v3.374c0 .311.252.563.563.563h3.374a.563.563 0 0 0 .563-.562v-3.376a.56.56 0 0 0-.562-.562"
        fill={theme.text.text}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OtherModules;
